import { useMemo } from 'react';

import { useGetPublicSharedMeetingData } from '@/api/generated';

const useSharedPublicMeeting = (sharedMeetingId: string) => {
  const {
    data: dataResponse,
    refetch: refetchSharedMeetingData,
    isLoading: sharedMeetingDataLoading
  } = useGetPublicSharedMeetingData(sharedMeetingId, {
    query: {
      queryKey: ['getPublicSharedMeetingData', sharedMeetingId],
      enabled: !!sharedMeetingId
    }
  });

  const sharedMeetingData = useMemo(() => dataResponse?.items?.[0] || null, [dataResponse?.items]);

  return {
    sharedMeetingData,
    refetchSharedMeetingData,
    sharedMeetingDataLoading
  };
};

export default useSharedPublicMeeting;
